import React, { useEffect, useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import { ordinalSuffixFormatter } from 'helper';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import * as actions from '../action';
import StructuralMaterialsModal from './components/StructuralMaterialsModal';

function StructuralMaterialList({
  dataInfo,
  type,
  floorArea,
  updateData,
  applicationId,
  getRoofList,
  getFlooringList,
  getWallsAndPartitionList
}) {

  const setModal = useContext(ModalContext);

  const formatType = (data) => {
    let val = '';
    switch (data) {
      case 'ROOF':
        val = 'Roof';
        break;
      case 'Roof':
        val = 'Roof';
        break;
      case 'Floor':
        val = 'Flooring';
        break;
      case 'Flooring':
        val = 'Flooring';
        break;
      case 'Walls & Partitions':
        val = 'Walls & Partitions';
        break;
      case 'Walls & Partitions Materials':
        val = 'Walls & Partitions';
        break;
      default:
        val = '';
        break;
    }
    return val;
  };

  const [viewForm, setViewForm] = useState(false);
  const [viewUpdateForm, setViewUpdateForm] = useState(false);
  const [formData, setFormData] = useState('');

  const [items, setItem] = useState({
    item: [],
  });

  useEffect(() => {
    let result = dataInfo;
    result = result.map((n, i) => {
      return {
        ...n,
        id: i + 1,
      };
    });
    setItem({
      item: result || [],
    });
  }, []);

  const closeUpdateModal = () => {
    setViewUpdateForm(false);
  };

  const handleOnUpdateForm = data => e => {
    e.preventDefault();
    setViewUpdateForm(true, setFormData({ ...data }));
  };

  const closeModal = () => {
    setViewForm(false);
  };

  const handleOnCancelClicked = () => {
    setModal({ isOpen: false });
  }

  const handleAddModal = e => {
    e.preventDefault();
    setViewForm(true);
    setViewUpdateForm(false);
  };

  const handleRemove = (data) => () => {

    ConfirmAlert(
      'Are you sure you want to remove this building material?',
      () => {
        const newItem = {
          item: (items.item || []).filter(x => x.id !== data.id)
        };
        setItem(newItem);
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleValueFromChild = (data) => {
    const newItem = {
      item: (items.item || []).concat([
        {
          id: (_.get(items, `item.${items.item.length - 1}.id`) || 0) + 1,
          rptax_building_material_type_id: _.get(data, 'rptax_building_material_type_id'),
          rptax_building_material_id: _.get(data, 'rptax_building_material_id'),
          rptax_building_material_type_name: _.get(data, 'rptax_building_material_type_name'),
          material_name: _.get(data, 'material_name'),
          floor: data.floor.concat([data.floor]),
          type,
        },
      ]),
    };
    setItem(newItem);
    setViewForm(false);
  };

  const handleOnUpdate = (updatedData) => {

    const finalItem = items.item.map(ele => {
      if (ele.id === updatedData.id) {
        return {
          ...ele,
          rptax_building_material_type_id: _.get(updatedData, 'rptax_building_material_type_id'),
          rptax_building_material_id: _.get(updatedData, 'rptax_building_material_id'),
          rptax_building_material_type_name: _.get(updatedData, 'rptax_building_material_type_name'),
          material_name: _.get(updatedData, 'material_name'),
          floor: _.get(updatedData, 'floor'),
          type
        };
      }
      return ele;
    });

    const newItem = {
      item: finalItem,
    };
    setItem(newItem);
    setFormData({});

    setViewUpdateForm(false);
  };

  const handleChange = (id, floorData, checked) => {

    const finalItem = items.item.map((row) => {
      if (row.id !== id) return row;

      const finalData = floorData.floor;

      const floorNo = row.floor;

      let updatedFloors = [...(floorNo || [])]

      if (checked) {
        // add floor if not already in array
        if (!updatedFloors.includes(finalData)) {
          updatedFloors.push(finalData);
        }
      } else {
        // remove floor when unchecked
        updatedFloors = updatedFloors.filter((f) => f !== finalData);
      }

      return { ...row, floor: updatedFloors };
    })

    const newItem = {
      item: finalItem,
    };

    setItem(newItem);
    setFormData({});
    setViewUpdateForm(false);
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const newList = (items.item || []).reduce((acc, data) => {
      const floor = (data.floor || []).map(x => x);

      const existing = acc.find(item =>
        item.rptax_building_material_type_id === data.rptax_building_material_type_id
      );

      if (existing) {
        existing.materials.push({
          rptax_building_material_id: data.rptax_building_material_id,
          floor
        });
      } else {
        acc.push({
          rptax_building_material_type_id: data.rptax_building_material_type_id,
          materials: [{
            rptax_building_material_id: data.rptax_building_material_id,
            floor
          }]
        });
      }
      return acc;
    }, []);

    updateData(applicationId, newList[0], () => {
      setModal({ isOpen: false });
      if (type === 'Roof') {
        getRoofList(applicationId, { isPaginate: 1, material_type_name: 'Roof' });
      }
      else if (type === 'Flooring') {
        getFlooringList(applicationId, { isPaginate: 1, material_type_name: 'Flooring' });
      } else {
        getWallsAndPartitionList(applicationId, { isPaginate: 1, material_type_name: 'Walls & Partitions' });
      }
    });

    return false;
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="col-12 mb-2">
          <div className="header-modal">
            Structural Materials Checklist
          </div>
          {viewUpdateForm === true || viewForm === true ? (
            ""
          ) : (
            <>
              <div className="row mb-3">
                <div className="col-8 mt-2 header-modal">
                  {type} Materials
                </div>
                {viewUpdateForm === true || viewForm === true ? (
                  " "
                ) : (
                  <div className="col-4 d-flex">
                    <div className="ml-auto">
                      <button
                        type="button"
                        onClick={handleAddModal}
                        className="btn button-transaction font-weight-bold"
                      >
                        <i className="fas fa-plus" /> &nbsp; Add {type} Material
                      </button>
                    </div>
                  </div>
                )}
              </div>
              {floorArea.length === 0 ? (
                <table className="table-structural table table-borderless table-sm mt-4">
                  <thead>
                    <tr className="cms-bg-color-primary-light cms-text-primary">
                      <th width="350">Materials</th>
                      <th width="200" style={{ textAlign: 'center' }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(items.item || [])
                      .filter(x => formatType(x.rptax_building_material_type_name) === type
                      )
                      .map((item, i) => (
                        <tr key={`Item ${i + 1}`}>
                          <td width="350">
                            <input
                              type="text"
                              readOnly
                              className="custom-input my-2"
                              value={_.get(item, 'material_name')}
                            />
                          </td>
                          <td className="text-center">
                            <div className="d-flex justify-content-center align-items center my-2">
                              <button
                                onClick={handleOnUpdateForm(item, i)}
                                type="button"
                                className="btn-blank btn-sm"
                                disabled={viewUpdateForm === true}
                              >
                                <i className="far fa-edit icon-edit" />
                              </button>
                              <button
                                type="button"
                                className="btn-blank btn-sm"
                                onClick={handleRemove(item)}
                              >
                                <i className="far fa-trash-alt icon-delete" />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              ) : (
                <>
                  <table id="myTable" className={`table-structural table table-borderless table-sm mt-4 ${floorArea.length > 0 ? 'w-1/2' : ''}`}>
                    <thead>
                      <tr className="cms-bg-color-primary-light cms-text-primary">
                        <th width="350">Materials</th>
                        <th width="200" style={{ textAlign: 'center' }}>Action</th>
                        {type === 'Flooring' && (
                          (floorArea || []).map((s) => (
                            <th key={s.id} style={{ textAlign: 'center' }}>{ordinalSuffixFormatter(s.floor)}</th>
                          ))
                        )}
                        {type === 'Walls & Partitions' && (
                          (floorArea || []).map((s) => (
                            <th key={s.id} style={{ textAlign: 'center' }}>{ordinalSuffixFormatter(s.floor)}</th>
                          ))
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {(items.item || [])
                        .filter(x =>
                          formatType(x.rptax_building_material_type_name) === type
                        )
                        .map((item, i) => (
                          <tr key={`Item ${i + 1}`}>
                            <td width="350">
                              <input
                                type="text"
                                readOnly
                                className="custom-input my-2"
                                value={_.get(item, 'material_name')}
                              />
                            </td>
                            <td className="text-center">
                              <div className="d-flex justify-content-center align-items center my-2">
                                <button
                                  onClick={handleOnUpdateForm(item, i)}
                                  type="button"
                                  className="btn-blank btn-sm"
                                  disabled={viewUpdateForm === true}
                                >
                                  <i className="far fa-edit icon-edit" />
                                </button>
                                <button
                                  type="button"
                                  className="btn-blank btn-sm"
                                  onClick={handleRemove(item)}
                                >
                                  <i className="far fa-trash-alt icon-delete" />
                                </button>
                              </div>
                            </td>
                            {item.rptax_building_material_type_name === 'Flooring' && (
                              (floorArea || []).map((s) => (
                                <td style={{ textAlign: 'center' }} key={s.id}>
                                  <input
                                    type="checkbox"
                                    checked={item.floor.includes(s.floor)}
                                    value={s}
                                    onChange={(e) =>
                                      handleChange(item.id, s, e.target.checked)
                                    }
                                  />
                                </td>
                              ))
                            )}
                            {item.rptax_building_material_type_name === 'Walls & Partitions' && (
                              (floorArea || []).map((s) => (
                                <td style={{ textAlign: 'center' }} key={s.id}>
                                  <input
                                    type="checkbox"
                                    checked={item.floor.includes(s.floor)}
                                    value={s}
                                    onChange={(e) =>
                                      handleChange(item.id, s, e.target.checked)
                                    }
                                  />
                                </td>
                              ))
                            )}
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </>
              )}
              {(viewUpdateForm === true || viewForm === true) ? (
                ""
              ) : (
                <>
                  <hr className="below-hr" />
                  <div className="d-flex justify-content-center mt-5">
                    <button
                      type="button"
                      onClick={handleOnCancelClicked}
                      className="btn btn-light button-cancel-2 mr-1"
                      style={{ backgroundColor: '#323943', color: '#fff' }}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-light button-proceed ml-1 cms-bg-color-primary"
                      style={{ color: '#fff' }}
                    >
                      Submit
                    </button>
                  </div>
                </>
              )}
            </>
          )}
          {
            viewForm === true && (
              <StructuralMaterialsModal
                closeModal={closeModal}
                handleOnParent={handleValueFromChild}
                type={type}
              />
            )
          }
          {
            viewUpdateForm === true && (
              <StructuralMaterialsModal
                closeModal={closeUpdateModal}
                dataInfo={formData}
                handleOnParent={handleOnUpdate}
                type={type}
              />
            )
          }
        </div>
      </form>
    </Modal.Body>
  );
}

StructuralMaterialList.defaultProps = {
  type: '',
  floorArea: [],
  applicationId: ''
};

StructuralMaterialList.propTypes = {
  dataInfo: PropTypes.instanceOf(Array).isRequired,
  type: PropTypes.string,
  applicationId: PropTypes.string,
  floorArea: PropTypes.instanceOf(Array),
  updateData: PropTypes.instanceOf(Function).isRequired,
  getRoofList: PropTypes.instanceOf(Function).isRequired,
  getFlooringList: PropTypes.instanceOf(Function).isRequired,
  getWallsAndPartitionList: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(StructuralMaterialList);